import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUnmount } from 'react-use';
import { fetchPropertyAvailability, clearResults } from 'store/propertyAvailability/propertyAvailabilityActions';
import RoomTypes from './RoomTypes';
import { getFullKnownQuery } from 'store/router/routerSelectors';
import { getIsExclusive } from 'store/property/propertySelectors';

// drop this down as a sub component so that changes to the query doesn't cause the RoomTypes to re-render unnecessarily
const ResultsFetcher = () => {
  const dispatch = useDispatch();

  // TODO: components should not listen to the full query.
  // Create a selector that listens to query params relevant to Property availability search.
  // This new selector can then be used in fetchPropertyAvailabilityLogic to pick relevant params for ava
  const query = useSelector(getFullKnownQuery);
  const isExclusive = useSelector(getIsExclusive);

  useEffect(() => {
    dispatch(fetchPropertyAvailability());
  }, [dispatch, query, isExclusive]);

  //clear results when we leave the page
  useUnmount(() => {
    dispatch(clearResults());
  });

  return null;
};

const PropertyAvailability = () => (
  <Fragment>
    <ResultsFetcher />
    <RoomTypes />
  </Fragment>
);

export default PropertyAvailability;
